function closeNotification(notification) {
	notification.slideUp(300, function() {
		notification.remove();
	});
}

function addNotification(title, message, icon) {
	icon = typeof icon === 'undefined' ? null : icon;

	var notification = $('<li>');
	if(icon) {
		notification.append('<figure><img src="'+icon+'" alt="icon"></figure>');
	}

	notification.append('<div class="notification"><header><h3>'+title+'</h3><a href="" class="close-notification icon-cancel"></a></header><p>'+message+'</p></div>');

	$('.notifications ul').append(notification);
	notification.hide();
	notification.fadeIn(300);

	setTimeout(function() {
		closeNotification(notification);
	}, 3300);
}

$('body').on('click', '.close-notification', function() {
    var notification = $(this).parents('li');
    closeNotification(notification);
    return false;
});